import { gql } from 'urql';

export const KARDEX_POR_PRODUCTO = gql`
  query KardexPorProducto($productoId: ID!, $sucursalId: ID, $desde: String, $hasta: String, $pagination: PaginationInput) {
    kardexPorProducto(
      productoId: $productoId
      sucursalId: $sucursalId
      desde: $desde
      hasta: $hasta
      pagination: $pagination
    ) {
      items {
        id
        fecha
        tipoMov
        referenciaTipo
        referenciaId
        cantidad
        costoUnit
        usuario
        saldoCantidad
        saldoValor
        sucursalId
      }
      pageInfo {
        total
        limit
        offset
      }
    }
  }
`;

export const STOCK_ACTUAL = gql`
  query StockActual($productoId: ID!, $sucursalId: ID) {
    stockActual(productoId: $productoId, sucursalId: $sucursalId) {
      productoId
      sucursalId
      cantidad
      valorPromedio
    }
  }
`;

export const AJUSTAR_STOCK = gql`
  mutation AjustarStock($productoId: ID!, $sucursalId: ID!, $cantidad: Float!, $motivo: String!, $usuario: String!) {
    ajustarStock(
      productoId: $productoId
      sucursalId: $sucursalId
      cantidad: $cantidad
      motivo: $motivo
      usuario: $usuario
    ) {
      productoId
      sucursalId
      cantidad
      valorPromedio
    }
  }
`;
